import { useState, useEffect } from 'react';
import { getUsers } from '../api/users';
import { User, PaginatedResponse, ListParams } from '../types/index';

interface UseUsersReturn {
  users: User[];
  total: number;
  isLoading: boolean;
  error: Error | null;
  refetch: (params?: ListParams) => Promise<void>;
}

export const useUsers = (params?: ListParams): UseUsersReturn => {
  const [users, setUsers] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = async (newParams?: ListParams) => {
    setIsLoading(true);
    setError(null);

    try {
      const data: PaginatedResponse<User> = await getUsers(newParams || params);
      setUsers(data.items);
      setTotal(data.total);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to fetch users');
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refetch();
  }, [params]);

  return { users, total, isLoading, error, refetch };
};
